import { combineReducers } from 'redux';
import { ratingStateReducer } from './rating-state/rating-state-reducer';
import { settingsReducer } from './settings-state/settings-reducer';

export const rootReducer = combineReducers({
  ratingState: ratingStateReducer,
  settings: settingsReducer,
});
